import React from "react";
import {connect} from "react-redux";
import {UserDto} from "../../../utils/types/user";
import {useParams} from "react-router";
import {Box} from "@reside/ui";

import {ResidentAdmissions} from "../../../atoms/resident-admissions-modal/ResidentAdmissions";
import {useShowResident} from "../../page-admin-residents-forms/hooks/useShowResident";
import {useHideResident} from "../../page-admin-residents-forms/hooks/useHideResident";
import {ResidentToggleButton} from "./ResidentToggleButton";
import {AdminLayoutFullHeightAndTwoCells} from "../../../atoms/admin-layout";
import {AdminPageTitle} from "../../../atoms/admin-layout/AdminPageTitle";
import {DocumentTitle} from "../../../atoms/document-title";
import {useFetchResident} from "../hooks/useFetchResident";
import {NotResideAdmin} from "../../../atoms/admin-roles";
import {ButtonLink} from "../../../atoms/button-link";
import {ResidentStatusTag} from "./ResidentStatusTag";
import {BackdropSpinner} from "../../../atoms/spinner";
import {AppState, select} from "../../../store";
import {ProfileCard} from "./ProfileCard";
import {BackButton} from "./BackButton";
import {Space} from "../../../atoms/space";

const Renderer = ({user}: {user: UserDto}): JSX.Element => {
  const {resident_uuid} = useParams<{resident_uuid: string}>();

  const {
    data: resident,
    isLoading,
    remove: clearStaleResident,
  } = useFetchResident(resident_uuid);

  const isArchived = resident?.is_archived;

  const {mutate: showResident} = useShowResident({refetch: clearStaleResident});
  const {mutate: hideResident} = useHideResident({refetch: clearStaleResident});

  return (
    <AdminLayoutFullHeightAndTwoCells>
      <BackdropSpinner active={isLoading}>
        <DocumentTitle title="Reside - Admin - Resident Profile" />
        {!isLoading ? (
          <div>
            <Box
              flexDirection="row"
              alignItems="center"
              justifyContent="space-between"
              flexShrink={0}
              className="adminactionrow-0-1"
              marginBottom="32px"
            >
              <AdminPageTitle
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 20,
                  maxHeight: "80px",
                }}
              >
                <BackButton removeResident={clearStaleResident} />
                <ResidentStatusTag status={resident?.status} />
              </AdminPageTitle>
              <Space>
                <NotResideAdmin>
                  <ResidentToggleButton
                    isArchived={Boolean(isArchived)}
                    residentId={resident?.id}
                    onHide={hideResident}
                    onShow={showResident}
                  />

                  {!Boolean(resident.pcc_patient_id) && (
                    <ButtonLink
                      outline={false}
                      color="primary"
                      to={`/admin/residents/edit/${resident?.id}`}
                    >
                      Edit Resident
                    </ButtonLink>
                  )}
                </NotResideAdmin>
              </Space>
            </Box>

            <ProfileCard resident={resident} user={user} />

            <ResidentAdmissions admissions={resident?.admissions} />
          </div>
        ) : null}
      </BackdropSpinner>
    </AdminLayoutFullHeightAndTwoCells>
  );
};

const mapState = (state: AppState) => ({
  user: select.adminSession.user(state),
});

export const ResidentProfile = connect(mapState)(Renderer);
